import { render, staticRenderFns } from "./CustomerActionDelete.vue?vue&type=template&id=9dd0ed9c&"
import script from "./CustomerActionDelete.vue?vue&type=script&lang=ts&"
export * from "./CustomerActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports